import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords }) => {
  const location = useLocation();

  useEffect(() => {
    // Set document title
    const fullTitle = title ? `${title} | Thingol Industries` : 'Thingol Industries - Digital Subconscious Mapping';
    document.title = fullTitle;

    // Set meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    const fullDescription = description || 'Thingol Industries: Advanced behavioral prediction and digital subconscious mapping technology supporting global organizations.';
    
    if (metaDescription) {
      metaDescription.setAttribute('content', fullDescription);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'description';
      newMeta.content = fullDescription;
      document.head.appendChild(newMeta);
    }

    // Set meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    const fullKeywords = keywords || 'digital subconscious mapping, behavioral prediction, rhizomal-node network analysis, human behavior analysis';
    
    if (metaKeywords) {
      metaKeywords.setAttribute('content', fullKeywords);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.name = 'keywords';
      newMeta.content = fullKeywords;
      document.head.appendChild(newMeta);
    }

    // Set canonical URL
    const canonicalUrl = `https://www.thingol.org${location.pathname}`;
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    
    if (canonicalLink) {
      canonicalLink.setAttribute('href', canonicalUrl);
    } else {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      canonicalLink.href = canonicalUrl;
      document.head.appendChild(canonicalLink);
    }

    // Set Open Graph tags
    const setMetaTag = (property, content) => {
      let metaTag = document.querySelector(`meta[property="${property}"]`);
      if (metaTag) {
        metaTag.setAttribute('content', content);
      } else {
        metaTag = document.createElement('meta');
        metaTag.setAttribute('property', property);
        metaTag.content = content;
        document.head.appendChild(metaTag);
      }
    };

    setMetaTag('og:title', fullTitle);
    setMetaTag('og:description', fullDescription);
    setMetaTag('og:url', canonicalUrl);
    setMetaTag('og:type', 'website');
    setMetaTag('og:site_name', 'Thingol Industries');

    // Set Twitter tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', fullTitle);
    setMetaTag('twitter:description', fullDescription);

  }, [title, description, keywords, location.pathname]);

  // This component doesn't render anything
  return null;
};

export default SEO;